import React from 'react';
import { useQuery } from '@apollo/client';
import { COUNTRY_BY_ID } from '../queriesAddress';

const CountryById = ({ id, mobile }) => {
    const {data, loading} = useQuery(COUNTRY_BY_ID, {
        variables: {
            id
        }
    })

    return (
        <>
            {mobile && !loading && data.country.full_name_locale}
            {!mobile && <span>{!loading && data.country.full_name_locale}</span>}
        </>
    )
};

export default CountryById;